export default __webpack_public_path__ + "locales/sr-Cyrl-RS/VersionHistory.json?hash=ec773624a708f5c9051043f0fd4ed3a2";